import React from 'react';
import Zmage from 'react-zmage';

import {AppBar, Button, Divider, IconButton, Paper, Snackbar, Toolbar, Typography} from '@material-ui/core';

import createMuiTheme from '@material-ui/core/styles/createMuiTheme';
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import CallMade from "@material-ui/icons/CallMade";
import axios from "axios";
import {chooseLocale, isWebpSupport, isWeiXin} from "../utils";

const theme = createMuiTheme({
    palette: {
        primary: {
            light: '#6e84b8',
            main: '#496ab8',
        },
        secondary: {
            light: '#6e84b8',
            main: '#496ab8',
        },
    },
});

const controller = {
    close: false,
    zoom: false,
    rotate: false,
    flip: false,
    pagination: true,
};

let android = null;
axios.get('https://api.chessease.net/app/versions/android/')
    .then((response) => {
        if (response.status === 200) {
            android = response.data['url'];
        }
    });


function appImg(name) {
    return 'https://chessease-public.oss-cn-beijing.aliyuncs.com/app/' + (chooseLocale().local === 'zh_CN' ? '' : 'en/') + name + (isWebpSupport() ? '.webp' : '.png');
}

// App

class App extends React.Component {

    constructor(props) {
        super(props);
        this.message = chooseLocale();
        this.state = {
            visibility: 'hidden',
            openSnackbar: false
        };
    }

    handleHome = () => {
        window.location.href = 'https://www.chessease.net';
    };

    handleAndroid = () => {
        if (android == null) {
            axios.get('https://api.chessease.net/app/versions/android/')
                .then((response) => {
                    if (response.status === 200) {
                        android = response.data['url'];
                        if (isWeiXin()) {
                            this.setState({openSnackbar: true});
                        } else {
                            window.open(android);
                        }
                    }
                });
        } else {
            if (isWeiXin()) {
                this.setState({openSnackbar: true});
            } else {
                window.open(android);
            }
        }
    };

    handleIOS = () => {
        window.open('https://itunes.apple.com/cn/app/guo-xiang-lian-meng/id1089848809');
    };

    handlePC = () => {
        window.open('https://a11.gdl.netease.com/MuMuInstaller_3.1.6.0_yx-gxlm_zh-Hans_1704443676.exe');
    };

    handleHidden = () => {
        this.setState({visibility: 'hidden'});
    };

    handleVisible = () => {
        this.setState({visibility: 'visible'});
    };

    handleCloseSnackbar = () => {
        this.setState({openSnackbar: false});
    };

    render() {
        return (window.innerHeight < window.innerWidth ? this.horizontal() : this.vertical());
    }

    horizontal() {
        return (
            <MuiThemeProvider theme={theme}>
                <div style={{position: "absolute", height: 800, top: 64, left: 0, right: 0, background: '#FAFAFA'}}>
                    <div style={{position: "absolute", width: 1280, height: 800, left: 0, right: 0, margin: "0 auto"}}>
                        <img style={{position: "absolute", width: 640, height: 700, top: '50%', transform: 'translateY(-50%)'}}
                             src={appImg('phone')} alt='phone'/>
                        <div style={{position: "absolute", width: 600, right: 0, top: '50%', transform: 'translateY(-50%)'}}>
                            <img style={{display: 'inline', width: 80, height: 80, marginLeft: 0, marginRight: 24}}
                                 src="/static/img/ic_launcher.svg" alt='icon' onClick={this.handleHome}/>
                            <Typography style={{display: 'inline-block', transform: 'translateY(-60%)'}}
                                        component="h2" variant="display1" gutterBottom onClick={this.handleHome}>
                                {this.message.app_name}
                            </Typography>
                            <Typography style={{lineHeight: '200%', marginTop: 16, whiteSpace: 'pre-line'}} variant="subheading" gutterBottom
                                        color='textSecondary'>
                                {this.message.app_describe}
                            </Typography>

                            <Button style={{display: 'inline', height: 48, marginTop: 32, marginRight: 24}} variant="contained" color="primary"
                                    onClick={this.handleAndroid}>
                                Android
                            </Button>
                            <Button style={{display: 'inline', height: 48, marginTop: 32, marginRight: 24}} variant="contained" color="primary"
                                    onClick={this.handleIOS}>
                                IOS
                            </Button>
                            <Button style={{display: 'inline', height: 48, marginTop: 32, marginRight: 24}} variant="contained" color="primary"
                                    onClick={this.handlePC}>
                                {this.message.pc_mumu}
                            </Button>
                            <Button style={{display: 'inline', height: 48, marginTop: 32, marginRight: 24}}
                                    variant="contained"
                                    color="primary"
                                    onMouseOver={this.handleVisible}
                                    onMouseOut={this.handleHidden}>
                                <img style={{position: "absolute", width: 24, height: 24, top: '50%', left: '50%', transform: 'translate(-50%,-50%)'}}
                                     src="/static/img/2.svg" alt='2'/>
                            </Button>
                        </div>

                        <div style={{
                            visibility: this.state.visibility,
                            position: "absolute", right: 162, bottom: 48, padding: 12,
                            border: '1px solid #d8d7d8',
                            borderRadius: 8,
                            backgroundColor: '#fff',
                            boxShadow: '0 10px 20px rgba(0,0,0,.2), inset 0 0 1px rgba(0,0,0,.04)'
                        }}>
                            <Typography style={{display: 'block', width: 128, textAlign: 'center'}} variant="body1" gutterBottom>
                                {this.message.txt_scan_download}
                            </Typography>
                            <img style={{display: 'block', width: 128, height: 128, marginTop: 8,}} src="/static/img/qr.svg" alt='qr'/>
                        </div>

                    </div>
                </div>

                <Paper style={{position: "absolute", width: '100%', height: 600, top: 864, background: '#FFFFFF'}} elevation={4} square={true}>
                    <div style={{position: "absolute", width: 1280, height: '100%', left: 0, right: 0, margin: "0 auto"}}>
                        <Typography style={{marginTop: 64, marginBottom: 32}} variant="contained" gutterBottom color='primary'>
                            {this.message.txt_app_screenshots}
                        </Typography>

                        <Divider style={{marginTop: 32, marginBottom: 64}}/>

                        <Zmage style={{display: 'inline', width: 238, height: 340, marginLeft: 5, marginRight: 10}} src={appImg('s1')} alt='s1'
                               controller={controller}
                               backdrop={"rgba(0,0,0,0.618)"}/>
                        <Zmage style={{display: 'inline', width: 238, height: 340, marginLeft: 10, marginRight: 10}} src={appImg('s2')} alt='s2'
                               controller={controller}
                               backdrop={"rgba(0,0,0,0.618)"}/>
                        <Zmage style={{display: 'inline', width: 238, height: 340, marginLeft: 10, marginRight: 10}} src={appImg('s3')} alt='s3'
                               controller={controller}
                               backdrop={"rgba(0,0,0,0.618)"}/>
                        <Zmage style={{display: 'inline', width: 238, height: 340, marginLeft: 10, marginRight: 10}} src={appImg('s4')} alt='s4'
                               controller={controller}
                               backdrop={"rgba(0,0,0,0.618)"}/>
                        <Zmage style={{display: 'inline', width: 238, height: 340, marginLeft: 10, marginRight: 5}} src={appImg('s5')} alt='s5'
                               controller={controller}
                               backdrop={"rgba(0,0,0,0.618)"}/>
                    </div>
                </Paper>

                <div style={{position: "absolute", width: '100%', top: 1464, paddingTop: 32, paddingBottom: 32, background: '#FAFAFA'}}>
                    <Typography style={{textAlign: 'center', marginTop: 8}} variant="body1" gutterBottom color='textSecondary'>
                        QQ: 2577830039&nbsp;&nbsp;&nbsp;&nbsp;E-mail: chessease@163.com
                    </Typography>
                    <div style={{display: "flex", justifyContent: "center", textAlign: 'center', marginTop: 8}}>
                        <Typography variant="body1" gutterBottom color='textSecondary'>
                            <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">
                                {this.message.app_icp}
                            </a>
                        </Typography>
                        <Typography variant="body1" gutterBottom color='textSecondary'>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                        </Typography>
                        <Typography variant="body1" gutterBottom color='textSecondary'>
                            {this.message.app_copyright}
                        </Typography>
                    </div>
                </div>

                <Divider style={{position: "absolute", width: "100%", top: 1464}}/>

                <AppBar position="absolute">
                    <Toolbar>
                        <img style={{width: 40, height: 40, marginLeft: 0, marginRight: 24}}
                             src="/static/img/ic_launcher.svg" alt='icon' onClick={this.handleHome}/>
                        <Typography variant="title" color="inherit" onClick={this.handleHome}>
                            {this.message.app_name}
                        </Typography>
                    </Toolbar>
                </AppBar>

            </MuiThemeProvider>
        );
    }

    vertical() {
        return (
            <MuiThemeProvider theme={theme}>
                <div style={{position: "absolute", top: 64, left: 0, right: 0, background: '#FAFAFA'}}>

                    <Typography style={{lineHeight: '200%', padding: 16, whiteSpace: 'pre-line'}} variant="subheading" gutterBottom
                                color='textSecondary'>
                        {this.message.app_describe}
                    </Typography>

                    <img style={{width: '90%', marginLeft: '10%', marginBottom: 24}} src={appImg('phone')} alt='phone'/>

                    <Paper style={{background: '#FFFFFF', padding: 16}} elevation={4} square={true}>
                        <Button style={{width: '100%', height: 48, marginTop: 16, marginBottom: 8}} variant="contained" color="primary"
                                onClick={this.handleAndroid}>
                            Android
                        </Button>
                        <Button style={{width: '100%', height: 48, marginTop: 8, marginBottom: 8}} variant="contained" color="primary"
                                onClick={this.handleIOS}>
                            IOS
                        </Button>
                        <Button style={{width: '100%', height: 48, marginTop: 8, marginBottom: 16}} variant="contained" color="primary"
                                onClick={this.handlePC}>
                            {this.message.pc_mumu}
                        </Button>
                    </Paper>

                    <Divider/>

                    <div style={{paddingTop: 24, paddingBottom: 24, background: '#FAFAFA'}}>
                        <Typography style={{textAlign: 'center', marginTop: 4}} variant="body1" gutterBottom color='textSecondary'>
                            QQ: 2577830039
                        </Typography>
                        <Typography style={{textAlign: 'center', marginTop: 4}} variant="body1" gutterBottom color='textSecondary'>
                            E-mail: chessease@163.com
                        </Typography>
                        <Typography style={{textAlign: 'center', marginTop: 4}} variant="body1" gutterBottom color='textSecondary'>
                            <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">
                                {this.message.app_icp}
                            </a>
                        </Typography>
                        <Typography style={{textAlign: 'center', marginTop: 4}} variant="body1" gutterBottom color='textSecondary'>
                            {this.message.app_copyright}
                        </Typography>
                    </div>

                </div>

                <AppBar position="absolute">
                    <Toolbar>
                        <img style={{width: 40, height: 40, marginLeft: 0, marginRight: 24}} src="/static/img/ic_launcher.svg" alt='icon'/>
                        <Typography variant="title" color="inherit">
                            {this.message.app_name}
                        </Typography>
                    </Toolbar>
                </AppBar>

                <Snackbar
                    anchorOrigin={{vertical: 'top', horizontal: 'center'}}
                    open={this.state.openSnackbar}
                    autoHideDuration={5000}
                    onClose={this.handleCloseSnackbar}
                    ContentProps={{'aria-describedby': 'message-id'}}
                    message={<span id="message-id"> {this.message.txt_open_in_browser}</span>}
                    action={[
                        <IconButton
                            key="close"
                            aria-label="Close"
                            color="inherit"
                            onClick={this.handleCloseSnackbar}>
                            <CallMade/>
                        </IconButton>,
                    ]}
                />

            </MuiThemeProvider>
        );
    }

}

export default App;



// WEBPACK FOOTER //
// ./src/index/app.js